module.exports = __webpack_public_path__ + "img/微量元素.de2a9fb1.png";